export default "__VITE_ASSET__DChhmfdq__"